<div class="modal-header">
    <h5 class="modal-title">Add Company List</h5>
    <button type="button" class="close" data-dismiss="modal" (click)="closeModal('dismiss')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    

<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
               
                <div class="card-body custom-datatables noscroll">
                    <div class="custom-datatables">
                        <form [formGroup]="addCompanyform" class="needs-validation" (ngSubmit)="onSubmit()">
                            <div class="row">
                                <div class="col-sm-12 col-xl-12">
                                   
                                        <div class="col-md-12 mb-3">
                                            <label for="nameOfInsider">Company Name</label>
                                            <input type="text" class="form-control"  id="company_list" placeholder="Company Name" formControlName="company_list" autocomplete="off" > 
                                                                                  
                                        </div>
                                        <div class="submit-btn">
                                            <button class="btn btn-primary"  type="submit">Save</button>   
                                            <button class="btn btn-warning" type="button" (click)="closeModal('close')">Cancel</button>                    
                                         </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
 </div>
</div>
<!-- <div class="modal-footer">
    <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closeModal('close')">Close</button>
</div> -->
